export const layerClass = {
  dropdown: { backdrop: null, panel: "tw-z-dropdown" },
  drawer: { backdrop: "tw-z-overlay", panel: "tw-z-drawer" },
  modal: { backdrop: "tw-z-overlay", panel: "tw-z-modal" },
  confirm: { backdrop: "tw-z-overlay", panel: "tw-z-confirm" },
  toast: { backdrop: null, panel: "tw-z-toast" },
  tooltip: { backdrop: null, panel: "tw-z-tooltip" },
} as const;
